var map = {
	"./AstonV.png": 6368,
	"./betcorrect-vleague-logo.svg": 6808,
	"./betslip.svg": 9706,
	"./ng-logo.svg": 3666,
	"./price-increase.svg": 2819,
	"./star-vleague-logo.png": 7189,
	"./teams/epl/Burnley.png": 7631,
	"./teams/epl/Everton.png": 6979,
	"./teams/epl/Liverpool.png": 2862,
	"./teams/epl/Southampton.png": 6642,
	"./teams/epl/arsenal.png": 4326,
	"./teams/epl/astonvilla.png": 9007,
	"./teams/epl/brentford.png": 7304,
	"./teams/epl/brightonhovealbion.png": 9086,
	"./teams/epl/chelsea.png": 2939,
	"./teams/epl/crystalpalace.png": 9102,
	"./teams/epl/leedsutd.png": 4776,
	"./teams/epl/leicestercity.png": 5955,
	"./teams/epl/manchestercity.png": 153,
	"./teams/epl/manutd.png": 5787,
	"./teams/epl/newcastleutd.png": 1553,
	"./teams/epl/norwich.png": 2740,
	"./teams/epl/tottenhamhotspur.png": 4119,
	"./teams/epl/watford.png": 5083,
	"./teams/epl/westhamutd.png": 2800,
	"./teams/epl/wolverhampton.png": 9294,
	"./teams/npfl/abiawarriors.png": 1761,
	"./teams/npfl/akwaunited.png": 3634,
	"./teams/npfl/bayeisaunited.png": 4988,
	"./teams/npfl/bendel.png": 4029,
	"./teams/npfl/dakkada.png": 4850,
	"./teams/npfl/domaunited.png": 511,
	"./teams/npfl/el-kanemiwarriors.png": 115,
	"./teams/npfl/enugurangers.png": 2427,
	"./teams/npfl/enyimba.png": 5212,
	"./teams/npfl/gombeunited.png": 4074,
	"./teams/npfl/kwaraunited.png": 8446,
	"./teams/npfl/lobistars.png": 6024,
	"./teams/npfl/nasarawaunited.png": 4030,
	"./teams/npfl/nigertornadoes.png": 4981,
	"./teams/npfl/plateauutd.png": 1776,
	"./teams/npfl/remostars.png": 8045,
	"./teams/npfl/riversutd.png": 805,
	"./teams/npfl/shootingstars.png": 9037,
	"./teams/npfl/sunshinestars.png": 8485,
	"./teams/npfl/wikkitourists.png": 2661,
	"./truewave-logo.svg": 7488,
	"./vleague-logo.svg": 4432,
	"./yanga-vleague-logo.png": 9225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;